// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p{
    margin-bottom: 0rem;
}
.MAcard{
    background: cyan;
    width: 30vw;
    height: auto;
    margin-top: 20px;
}
.MAcard ul li form{
    display: inline;
    margin-left: 13px;
}
.MAcard ul li{
    display: inline;
    list-style: none;
    justify-content:space-around;
    justify-items:auto;
}
.MAprofile-picture img{
    width: 50px;
    border-radius: 50%;
    display: inline-block;
}
.MAdeactive-status input{
    display: inline-block;
}
#deactivate-text{
    display: inline-block;
}
.MAprofile-picture{
    
}

/* body{
    margin-top: 20px;

    margin-bottom: 1000px;
} */

.MAcards-in-row{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 30px;
    row-gap: 30px;
    padding: 10px 20px;

}

.MAcard{
    background-color: rgb(248, 248, 248);
   
    border: 2px solid black;
    border-radius: 10px;
}

.MAcard-head{
    display: flex;
    justify-content: space-between;

}

.MAdeactive-status{
    flex: 1 1;
    display: flex;
    align-items: center;
    padding: 10px 10px 20px 10px;
}

.MAdeactive-checkbox{
    margin-right: 5px;
    margin-bottom: 0;
}

.MAprofile-picture{
    flex: 2 1;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;

}

.MAuser-profile-picture{
    height: 50px;
    border-radius: 25px;
}

.MAuser-role{
    display: flex;
    flex: 1 1;
    align-items: center;
    justify-content: center;
}

.MAdropdown-menu{
    font-size: 16px;
}


.MAuser-details{
    display: flex;
    justify-content: space-between;
    padding: 5px 10px;
}

@media screen and (max-width: 700px) 
{
    .MAuser-details{
        display: flex;
        flex-direction: column;
        /* justify-content: space-between; */
        padding: 5px 10px;
    }
}

.MAdob-phone p{
    text-align: end;
}

.MAcourse-module{
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    padding: 15px 10px;
    align-items: center;
}
.MAsave-button{
    display: flex;
    justify-content: space-around;
    padding: 0 10px 10px 0;
    align-items: center;
}
.MAsave-button a:hover{

    color: black;
 
   
}
.MAsave-button button{
    background-color: rgb(3, 180, 198);
    border: none;
    color: white;
    padding: 8px 50px;
    border-radius: 4px;
   

}

.MAtype-message{
    display: flex;
}

.MAtype-message input{
    flex: 1 1;
    padding: 9px 6px;
    margin: 0 10px;
}

.MAcard-foot{
   display: grid;
   grid-template-columns: 1fr 1fr;
   padding: 10px 10px;

}

.MAcard-foot div a{
    text-decoration: none;
    color: rgb(3, 180, 198);
    font-weight: bold;
}

.MAupper-right{
    display: flex;
    justify-content: center;
}

.loading-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh; 
  }
  
  .loading-container p {
    margin-top: 10px; 
    font-size: 16px; 
    color: rgb(3, 180, 198); 
  }
  
  @media screen and (max-width: 1090px) 
  {
      .MAcards-in-row{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
      }
      .MAcard{
          width: 60%;
      }
  }
@media screen and (max-width: 700px) 
{
    .MAcards-in-row{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .MAcard{
        width: 90%;
    }
}



.MAdropdown-fixed-width {
    width: 100px; /* Set the desired width here */
  }
  /* Existing styles... */

.search-filters {
    display: flex;
    justify-content: space-between; /* Distributes space between elements */
    align-items: center; /* Centers items vertically */
    margin: 20px 10%; /* Adds margin above and below and 10% margin on the sides */
}

.search-filters input {
    flex: 1 1; /* Allows the input to grow */
    padding: 8px; /* Decreased padding for a smaller input */
    border: 1px solid #ccc; /* Sets a border color */
    border-radius: 4px; /* Rounds the corners */
    margin-right: 10px; /* Adds space between the input and dropdowns */
    max-width: 250px; /* Sets a maximum width for the input */
}

.MAdropdown-menu {
    padding: 8px; /* Decreased padding for a smaller dropdown */
    border: 1px solid #ccc; /* Sets a border color */
    border-radius: 4px; /* Rounds the corners */
    flex: 1 1; /* Allows dropdowns to grow */
    /* margin-left: 10px;  */
    /* max-width: 200px; */
    /* width:80%; */
}
.search-filters-container {
    background-color: #003366; /* Dark blue background */
    padding: 5px; /* Adds padding inside the background box */
    border-radius: 1px; /* Rounds the corners of the box */
    margin: auto /* Keeps margin for positioning */
}


@media screen and (max-width: 700px) {
    .search-filters {
        flex-direction: column; /* Stacks elements vertically on small screens */
        align-items: stretch; /* Stretches items to full width */
    }

    .search-filters input,
    .MAdropdown-menu {
        margin: 5px 0; /* Adds vertical spacing between elements */
        max-width: 100%; /* Makes inputs and dropdowns full width on small screens */
    }
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/ManageUser/User.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;;AAEA;;AAEA;;;;GAIG;;AAEH;IACI,aAAa;IACb,kCAAkC;IAClC,gBAAgB;IAChB,aAAa;IACb,kBAAkB;;AAEtB;;AAEA;IACI,oCAAoC;;IAEpC,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;;AAElC;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAO;IACP,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;;IAEI;QACI,aAAa;QACb,sBAAsB;QACtB,oCAAoC;QACpC,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;AACvB;AACA;;IAEI,YAAY;;;AAGhB;AACA;IACI,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;;;AAGtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,cAAc;AAClB;;AAEA;GACG,aAAa;GACb,8BAA8B;GAC9B,kBAAkB;;AAErB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,uBAAuB;EACzB;;EAEA;;MAEI;UACI,aAAa;UACb,sBAAsB;UACtB,mBAAmB;UACnB,uBAAuB;MAC3B;MACA;UACI,UAAU;MACd;EACJ;AACF;;IAEI;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,UAAU;IACd;AACJ;;;;AAIA;IACI,YAAY,EAAE,+BAA+B;EAC/C;EACA,uBAAuB;;AAEzB;IACI,aAAa;IACb,8BAA8B,EAAE,uCAAuC;IACvE,mBAAmB,EAAE,6BAA6B;IAClD,gBAAgB,EAAE,4DAA4D;AAClF;;AAEA;IACI,SAAO,EAAE,6BAA6B;IACtC,YAAY,EAAE,0CAA0C;IACxD,sBAAsB,EAAE,wBAAwB;IAChD,kBAAkB,EAAE,uBAAuB;IAC3C,kBAAkB,EAAE,+CAA+C;IACnE,gBAAgB,EAAE,uCAAuC;AAC7D;;AAEA;IACI,YAAY,EAAE,6CAA6C;IAC3D,sBAAsB,EAAE,wBAAwB;IAChD,kBAAkB,EAAE,uBAAuB;IAC3C,SAAO,EAAE,6BAA6B;IACtC,wBAAwB;IACxB,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,yBAAyB,EAAE,yBAAyB;IACpD,YAAY,EAAE,2CAA2C;IACzD,kBAAkB,EAAE,kCAAkC;IACtD,WAAW,EAAE,iCAAiC;AAClD;;;AAGA;IACI;QACI,sBAAsB,EAAE,gDAAgD;QACxE,oBAAoB,EAAE,kCAAkC;IAC5D;;IAEA;;QAEI,aAAa,EAAE,2CAA2C;QAC1D,eAAe,EAAE,2DAA2D;IAChF;AACJ","sourcesContent":["p{\n    margin-bottom: 0rem;\n}\n.MAcard{\n    background: cyan;\n    width: 30vw;\n    height: auto;\n    margin-top: 20px;\n}\n.MAcard ul li form{\n    display: inline;\n    margin-left: 13px;\n}\n.MAcard ul li{\n    display: inline;\n    list-style: none;\n    justify-content:space-around;\n    justify-items:auto;\n}\n.MAprofile-picture img{\n    width: 50px;\n    border-radius: 50%;\n    display: inline-block;\n}\n.MAdeactive-status input{\n    display: inline-block;\n}\n#deactivate-text{\n    display: inline-block;\n}\n.MAprofile-picture{\n    \n}\n\n/* body{\n    margin-top: 20px;\n\n    margin-bottom: 1000px;\n} */\n\n.MAcards-in-row{\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    column-gap: 30px;\n    row-gap: 30px;\n    padding: 10px 20px;\n\n}\n\n.MAcard{\n    background-color: rgb(248, 248, 248);\n   \n    border: 2px solid black;\n    border-radius: 10px;\n}\n\n.MAcard-head{\n    display: flex;\n    justify-content: space-between;\n\n}\n\n.MAdeactive-status{\n    flex: 1;\n    display: flex;\n    align-items: center;\n    padding: 10px 10px 20px 10px;\n}\n\n.MAdeactive-checkbox{\n    margin-right: 5px;\n    margin-bottom: 0;\n}\n\n.MAprofile-picture{\n    flex: 2;\n    height: 60px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.MAuser-profile-picture{\n    height: 50px;\n    border-radius: 25px;\n}\n\n.MAuser-role{\n    display: flex;\n    flex: 1;\n    align-items: center;\n    justify-content: center;\n}\n\n.MAdropdown-menu{\n    font-size: 16px;\n}\n\n\n.MAuser-details{\n    display: flex;\n    justify-content: space-between;\n    padding: 5px 10px;\n}\n\n@media screen and (max-width: 700px) \n{\n    .MAuser-details{\n        display: flex;\n        flex-direction: column;\n        /* justify-content: space-between; */\n        padding: 5px 10px;\n    }\n}\n\n.MAdob-phone p{\n    text-align: end;\n}\n\n.MAcourse-module{\n    display: flex;\n    flex-direction: column;\n    /* justify-content: space-between; */\n    padding: 15px 10px;\n    align-items: center;\n}\n.MAsave-button{\n    display: flex;\n    justify-content: space-around;\n    padding: 0 10px 10px 0;\n    align-items: center;\n}\n.MAsave-button a:hover{\n\n    color: black;\n \n   \n}\n.MAsave-button button{\n    background-color: rgb(3, 180, 198);\n    border: none;\n    color: white;\n    padding: 8px 50px;\n    border-radius: 4px;\n   \n\n}\n\n.MAtype-message{\n    display: flex;\n}\n\n.MAtype-message input{\n    flex: 1;\n    padding: 9px 6px;\n    margin: 0 10px;\n}\n\n.MAcard-foot{\n   display: grid;\n   grid-template-columns: 1fr 1fr;\n   padding: 10px 10px;\n\n}\n\n.MAcard-foot div a{\n    text-decoration: none;\n    color: rgb(3, 180, 198);\n    font-weight: bold;\n}\n\n.MAupper-right{\n    display: flex;\n    justify-content: center;\n}\n\n.loading-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh; \n  }\n  \n  .loading-container p {\n    margin-top: 10px; \n    font-size: 16px; \n    color: rgb(3, 180, 198); \n  }\n  \n  @media screen and (max-width: 1090px) \n  {\n      .MAcards-in-row{\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          justify-content: center;\n      }\n      .MAcard{\n          width: 60%;\n      }\n  }\n@media screen and (max-width: 700px) \n{\n    .MAcards-in-row{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n    }\n    .MAcard{\n        width: 90%;\n    }\n}\n\n\n\n.MAdropdown-fixed-width {\n    width: 100px; /* Set the desired width here */\n  }\n  /* Existing styles... */\n\n.search-filters {\n    display: flex;\n    justify-content: space-between; /* Distributes space between elements */\n    align-items: center; /* Centers items vertically */\n    margin: 20px 10%; /* Adds margin above and below and 10% margin on the sides */\n}\n\n.search-filters input {\n    flex: 1; /* Allows the input to grow */\n    padding: 8px; /* Decreased padding for a smaller input */\n    border: 1px solid #ccc; /* Sets a border color */\n    border-radius: 4px; /* Rounds the corners */\n    margin-right: 10px; /* Adds space between the input and dropdowns */\n    max-width: 250px; /* Sets a maximum width for the input */\n}\n\n.MAdropdown-menu {\n    padding: 8px; /* Decreased padding for a smaller dropdown */\n    border: 1px solid #ccc; /* Sets a border color */\n    border-radius: 4px; /* Rounds the corners */\n    flex: 1; /* Allows dropdowns to grow */\n    /* margin-left: 10px;  */\n    /* max-width: 200px; */\n    /* width:80%; */\n}\n.search-filters-container {\n    background-color: #003366; /* Dark blue background */\n    padding: 5px; /* Adds padding inside the background box */\n    border-radius: 1px; /* Rounds the corners of the box */\n    margin: auto /* Keeps margin for positioning */\n}\n\n\n@media screen and (max-width: 700px) {\n    .search-filters {\n        flex-direction: column; /* Stacks elements vertically on small screens */\n        align-items: stretch; /* Stretches items to full width */\n    }\n\n    .search-filters input,\n    .MAdropdown-menu {\n        margin: 5px 0; /* Adds vertical spacing between elements */\n        max-width: 100%; /* Makes inputs and dropdowns full width on small screens */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
